import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { recoverPassword } from "../actions/auth";
import Alert from "./presentational/Alert";
import AlertSwitch from "./presentational/AlertSwitch";
const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const { success, error } = useSelector((state) => state.auth.requests.recoverPassword);
    const dispatch = useDispatch();
    useEffect(() => {
        if (success) {
            setEmail("");
        }
    }, [success]);
    return (React.createElement("section", { className: "popup-form" },
        React.createElement("div", { className: "cube-wrap" },
            React.createElement("div", { className: "cube cube-w1" }),
            React.createElement("div", { className: "cube cube-w2" }),
            React.createElement("div", { className: "cube cube-w3" })),
        React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "row justify-content-center" },
                React.createElement("div", { className: "col-xl-6 col-lg-8 col-md-10 col-11" },
                    React.createElement("div", { className: "pf_wrap" },
                        React.createElement("div", { className: "pf_title text-c" },
                            React.createElement("h2", null, "Password Recovery")),
                        React.createElement(Alert, { kind: "warning", className: "pf_input" }, "Voicery has shut down. Password recovery is disabled."),
                        React.createElement(AlertSwitch, { error: error, success: success ? "Success! Check your inbox." : "", className: "pf_input" }),
                        React.createElement("form", { className: "pf_form", onSubmit: e => {
                                e.preventDefault();
                                dispatch(recoverPassword.request({ email }));
                            } },
                            React.createElement("div", { className: "pf_input" },
                                React.createElement("input", { type: "text", placeholder: "Email Address", "aria-label": "Email Address", value: email, onChange: e => setEmail(e.target.value) })),
                            React.createElement("div", { className: "pf_f-text" },
                                React.createElement(Link, { className: "popup-link", to: "/login" }, "Remember your password?")),
                            React.createElement("div", { className: "pf_btn" },
                                React.createElement("button", { type: "submit", className: "btn-blue btn-blue_big", disabled: true }, "Reset Password")),
                            React.createElement("div", { className: "pf_b-text" },
                                React.createElement("p", null,
                                    "New?",
                                    " ",
                                    React.createElement(Link, { className: "popup-link", to: "/signup" }, "Sign up"),
                                    " ",
                                    "instead.")))))))));
};
export default ForgotPassword;
